"use client";

import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import type { AssetDetail } from "@/hooks/useAssetDetail";
import { buildAssetSpecRows } from "@/lib/asset-spec-table";

interface AssetSpecTableProps {
  asset: AssetDetail;
  id?: string;
}

export function AssetSpecTable({ asset, id = "asset-specs" }: AssetSpecTableProps) {
  const rows = buildAssetSpecRows(asset);

  return (
    <section aria-labelledby={`${id}-heading`} className="scroll-mt-24">
      <h2 id={`${id}-heading`} className="font-display text-xl font-semibold tracking-tight mb-4">
        Technical specs
      </h2>
      <div className="rounded-xl border border-border bg-card/50 overflow-hidden">
        <Table>
          <TableHeader>
            <TableRow className="hover:bg-transparent border-border/60">
              <TableHead className="w-[40%] text-muted-foreground font-mono text-xs uppercase tracking-wide">
                Spec
              </TableHead>
              <TableHead className="text-muted-foreground font-mono text-xs uppercase tracking-wide">
                Value
              </TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {rows.map((row) => (
              <TableRow key={row.label} className="border-border/60">
                <TableCell className="font-medium text-foreground align-top py-3">{row.label}</TableCell>
                <TableCell className="font-mono text-sm text-muted-foreground align-top py-3 tabular-nums">
                  {row.value}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </section>
  );
}
